export const MidParallax = () => {
  return (
    <section
      className="relative h-[250px] md:h-[350px] bg-fixed bg-center bg-cover bg-no-repeat"
      style={{ backgroundColor: '#1A1A1A', backgroundImage: 'linear-gradient(135deg, #1A1A1A 0%, #3A2210 50%, #1A1A1A 100%)' }}
    >
      <div className="absolute inset-0 bg-primary/50" />
      <div className="relative z-10 h-full flex items-center justify-center">
        <div className="text-center px-4">
          <p className="text-secondary text-sm md:text-base font-semibold tracking-widest uppercase mb-3 font-subheading">
            Quality You Can Trust
          </p>
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-white">
            BUILT FOR MINNESOTA HOMES
          </h2>
          <p className="text-white/80 text-base md:text-lg mt-3 max-w-xl mx-auto">
            Expert exterior solutions engineered for the harshest climates.
          </p>
        </div>
      </div>
    </section>
  );
};
